import { HttpApiService } from "@/shared/services/httpApi.service";
import type { PaginationParams } from "@/shared/types/pagination.types";

import { NOTIFICATIONS_API_ENDPOINTS, NOTIFICATIONS_PAGE_SIZE } from "../constants/notifications.constants";
import type { NotificationItem, NotificationsListResponse } from "../types/notifications-api.types";

export type FetchNotificationsParams = PaginationParams & {
  /** Optional override of the REST endpoint to call. The registry passes this in. */
  endpoint?: string;
};

export type MarkAsReadParams = {
  id: string;
  /** Optional override of the REST endpoint. The registry passes this in. */
  endpoint?: string;
};

export const notificationsService = {
  fetchList: async (params?: FetchNotificationsParams): Promise<NotificationsListResponse> => {
    const path = params?.endpoint ?? NOTIFICATIONS_API_ENDPOINTS.NOTIFICATIONS;
    const queryParams: string[] = [];
    if (params?.skip != null) queryParams.push(`skip=${params.skip}`);
    if (params?.limit != null) queryParams.push(`limit=${params.limit}`);
    const url = queryParams.length ? `${path}?${queryParams.join("&")}` : path;
    const response = await HttpApiService.get<NotificationsListResponse>(url);
    return response.data;
  },

  markAsRead: async (params: MarkAsReadParams): Promise<NotificationItem | void> => {
    const path = params.endpoint ?? NOTIFICATIONS_API_ENDPOINTS.markAsRead(params.id);
    const response = await HttpApiService.patch<NotificationItem>(path, {});
    return response.data;
  },
};

export const DEFAULT_NOTIFICATIONS_LIMIT = NOTIFICATIONS_PAGE_SIZE;
